import {getSiblings} from "@main/helpers/dom";
import {getCookie} from "@main/utils/cookie";
import focusManager from "focus-manager";
import {ToggleScroll} from "@main/components/toggle-scroll";

/** Класс калькулятора ЕГЭ. */
class ExamCalculator {
    documentEl = document.body

    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.cookieName = this.el.dataset.cookie;

        this.findElements();
        this.bindEventListeners();
    }

    /**
     * Поиск элементов компонента.
     *
     * @returns {void}
     */
    findElements() {
        this.buttonSubmit = this.el.querySelector(".js-form-submit-btn");
        this.inputs = [...this.el.querySelectorAll("input[type='number']")];
        this.modal = this.documentEl.querySelector(".js-modal-calculator");
        this.inputs = [...this.modal.querySelectorAll("input[type='number']")];
        this.inputsModal = this.modal.querySelectorAll("input");
        this.inputName = this.modal.querySelector(".js-calculator-name");
        this.inputPhone = this.modal.querySelector(".js-calculator-phone");
        this.submitButtonModal = this.modal.querySelector(".js-form-submit-btn");
    }

    /**
     * Привязка обработчиков событий.
     * 
     * В поле ввода калькулятора допустумо вводить только цифры.
     * В зависимости от введенного балла, поле будет подсвечиваться:
     * - зеленым цветом, если балл в пределах от минимально допустимого до 100;
     * - красным цветом, если балл меньше минимально допустимого или больше 100.
     * 
     * @returns {void}
     */
    bindEventListeners() {
        this.el.addEventListener("keyup", (event) => {            
            if (event.target.matches("input")) {                
                const input = event.target;
                const card = input.closest(".js-calculator-card");
                const minScore = Number(card.dataset.minScore);
                const maxScore = Number(input.getAttribute("max"));
                const siblings = getSiblings(input.closest(".js-calculator-card"));

                input.value = input.value.replace(/[^0-9]/, "");
                
                if (input.value >= minScore && input.value <= maxScore) {
                    card.classList.remove("calculator-card--failed");
                    card.classList.add("calculator-card--success");
                    this.buttonSubmit.removeAttribute("disabled");
                } else if ((input.value < minScore || input.value > maxScore) && input.value !== "") {
                    card.classList.remove("calculator-card--success");
                    card.classList.add("calculator-card--failed");
                    this.buttonSubmit.removeAttribute("disabled");
                } else if (input.value == "") {
                    input.value = "";
                    card.classList.remove("calculator-card--success", "calculator-card--failed"); 
                } 
                
                siblings.forEach(sibling => {
                    const inputCard = sibling.querySelector("input");
                    if (inputCard.value !== "") {
                        this.buttonSubmit.removeAttribute("disabled");
                    }
                });
            }
        });

        this.buttonSubmit.addEventListener("click", () => {
            if (getCookie(this.cookieName)) {
                this.el.nextElementSibling.remove();
                const url = new URL(location);
                this.inputs.forEach(input => {
                    if (input.value) {
                        url.searchParams.set(input.name, input.value);
                    }
                })
                history.pushState({}, "", url);
            } else {
                this.modal.classList.add("shown");
                ToggleScroll.disable(this.modal);
                focusManager.capture(this.modal);
                return false;
            }
        });

        this.inputs.forEach(input => {
            input.addEventListener("wheel", (e) => e.preventDefault());
        });

        this.inputsModal.forEach(input => {
            input.addEventListener("input", () => {
                this.checkSubmitBtn();
            });
            input.addEventListener("change", () => {
                this.checkSubmitBtn();
            })
        });
    }

    checkSubmitBtn() {
        if (this.inputName.value !== "" && this.inputPhone.value !== "" && this.inputPhone.value.length === 18) {
            this.submitButtonModal.removeAttribute("disabled");
        } else {
            this.submitButtonModal.setAttribute("disabled", "disabled");
        }
    }
}

document.querySelectorAll(".js-сalculator").forEach((el) => new ExamCalculator(el));
